export enum PaymentSourceType {
  CardConnect = 1,
  Cornerstone = 2,
  PayPal = 3,
  Bitcoin = 4
}
